import type AuthenticationContext from './AuthenticationContext'
import { extractProfileClaims } from './profileClaims'
import userManager from './userManager'

const requireAuthContext = async (): Promise<AuthenticationContext> => {
  let user = await userManager.getUser()
  if (!user || !user.access_token || user.expired) {
    user = await userManager.signinSilent().catch(() => null)
  }
  if (!user || !user.access_token || user.expired) throw new Error('Not authenticated. Please sign in and try again.')

  const { organizationId, userEntityId } = extractProfileClaims(user.profile)
  if (!organizationId || !userEntityId)
    throw new Error(
      'Authentication context is missing. This may be because your user account is not linked to a user entity. Please contact support for assistance.'
    )

  return { accessToken: user.access_token, organizationId, userEntityId }
}

export default requireAuthContext
